import React, { CSSProperties } from 'react';
import Video from '../Video';
import { VideoType } from '../../types';
import WofButton from '../WofButton';
import { videoGalleryIds } from '../../analyticsTags';
import './styles.scss';

const VideoGallery: React.FC<VideoType> = props => {
  const { title, ctaText, ctaLink, titleColor, background,ctabaseColor,ctahoverColor } = props;

  const bgStyle: CSSProperties = {};
  let hasbgImage = Boolean(background);

  if (hasbgImage) {
    bgStyle.backgroundImage = `url("${background}")`;
  }
 
  return (
    <div
      style={{ ...bgStyle }}
      className={`thumbnail-slider bonus space${
        hasbgImage ? ' bg-image' : ''
      }`}>
      <div className="container">
        <div className="row">
          <div className="col-12 section-title watch text-center">
            <h2 style={{ color: titleColor }}>{title}</h2>
          </div>
          <div className="col-12 col-xl-10 offset-xl-1">
            <Video {...props} />
          </div>
          <div className="col-12 text-center">
            <WofButton id={videoGalleryIds.cta} href={ctaLink} baseColor={ctabaseColor} hoverColor={ctahoverColor} >
              {ctaText}
            </WofButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoGallery;
